export interface HuafendaLightingOption {
  labelKey: string;
  value: number;
  original: string;
}
// i18next-extract-mark-ns-start huafenda-lighting-dynamic
// Dynamic keys used in this file:
// t("keyboard.lighting.huafenda.off")
// t("keyboard.lighting.huafenda.static")
// t("keyboard.lighting.huafenda.pressLight")
// t("keyboard.lighting.huafenda.releaseOff")
// t("keyboard.lighting.huafenda.starry")
// t("keyboard.lighting.huafenda.snowFly")
// t("keyboard.lighting.huafenda.blossom")
// t("keyboard.lighting.huafenda.breathing")
// t("keyboard.lighting.huafenda.spectrum")
// t("keyboard.lighting.huafenda.spring")
// t("keyboard.lighting.huafenda.colorful")
// t("keyboard.lighting.huafenda.wave")
// t("keyboard.lighting.huafenda.peakTurn")
// t("keyboard.lighting.huafenda.instant")
// t("keyboard.lighting.huafenda.doubleHit")
// t("keyboard.lighting.huafenda.ripple")
// t("keyboard.lighting.huafenda.flow")
// t("keyboard.lighting.huafenda.mountain")
// t("keyboard.lighting.huafenda.rain")
// t("keyboard.lighting.huafenda.shuttle")
// t("keyboard.lighting.huafenda.heartbeat")
// t("keyboard.lighting.huafenda.custom")
// i18next-extract-mark-ns-end huafenda-lighting-dynamic

export const huafendaLightingData: HuafendaLightingOption[] = [
  { labelKey: "keyboard.lighting.huafenda.off", value: 9999, original: "9999" },
  { labelKey: "keyboard.lighting.huafenda.static", value: 1, original: "0x01" },
  {
    labelKey: "keyboard.lighting.huafenda.pressLight",
    value: 2,
    original: "0x02",
  },
  {
    labelKey: "keyboard.lighting.huafenda.releaseOff",
    value: 3,
    original: "0x03",
  },
  { labelKey: "keyboard.lighting.huafenda.starry", value: 4, original: "0x04" },
  {
    labelKey: "keyboard.lighting.huafenda.snowFly",
    value: 5,
    original: "0x05",
  },
  {
    labelKey: "keyboard.lighting.huafenda.blossom",
    value: 6,
    original: "0x06",
  },
  {
    labelKey: "keyboard.lighting.huafenda.breathing",
    value: 7,
    original: "0x07",
  },
  {
    labelKey: "keyboard.lighting.huafenda.spectrum",
    value: 8,
    original: "0x08",
  },
  { labelKey: "keyboard.lighting.huafenda.spring", value: 9, original: "0x09" },
  {
    labelKey: "keyboard.lighting.huafenda.colorful",
    value: 10,
    original: "0x0A",
  },
  { labelKey: "keyboard.lighting.huafenda.wave", value: 11, original: "0x0B" },
  {
    labelKey: "keyboard.lighting.huafenda.peakTurn",
    value: 12,
    original: "0x0C",
  },
  {
    labelKey: "keyboard.lighting.huafenda.instant",
    value: 13,
    original: "0x0D",
  },
  {
    labelKey: "keyboard.lighting.huafenda.doubleHit",
    value: 14,
    original: "0x0E",
  },
  {
    labelKey: "keyboard.lighting.huafenda.ripple",
    value: 15,
    original: "0x0F",
  },
  { labelKey: "keyboard.lighting.huafenda.flow", value: 16, original: "0x10" },
  {
    labelKey: "keyboard.lighting.huafenda.mountain",
    value: 17,
    original: "0x11",
  },
  { labelKey: "keyboard.lighting.huafenda.rain", value: 18, original: "0x12" },
  {
    labelKey: "keyboard.lighting.huafenda.shuttle",
    value: 19,
    original: "0x13",
  },
  {
    labelKey: "keyboard.lighting.huafenda.heartbeat",
    value: 254,
    original: "0xfe",
  },
  {
    labelKey: "keyboard.lighting.huafenda.custom",
    value: 20,
    original: "0x80",
  },
];

export const huafendaLightingBoxData: any[] = [
  {
    labelKey: "keyboard.lighting.huafendaLightingBox.off",
    value: 5,
    original: "off",
  },
  {
    labelKey: "keyboard.lighting.huafendaLightingBox.flowingLight",
    value: 1,
    original: "flowingLight",
  },
  {
    labelKey: "keyboard.lighting.huafendaLightingBox.staticConstantBrightness",
    value: 2,
    original: "staticConstantBrightness",
  },
  {
    labelKey: "keyboard.lighting.huafendaLightingBox.dynamicBreathing",
    value: 3,
    original: "dynamicBreathing",
  },
  {
    labelKey: "keyboard.lighting.huafendaLightingBox.spectralCycle",
    value: 4,
    original: "spectralCycle",
  },
  // {
  //   labelKey: "keyboard.lighting.huafendaLightingBox.agile",
  //   value: 6,
  //   original: "agile",
  // },
  // {
  //   labelKey: "keyboard.lighting.huafendaLightingBox.chainReaction",
  //   value: 7,
  //   original: "chainReaction",
  // },
];
// export default huafendaLightingData;
